(function($) {
  'use strict';

  
}(jQuery));
